var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 23.4985C40 34.5442 27.5472 40 16.5015 40C5.45576 40 0 27.5472 0 16.5015C0 5.45576 12.4528 0 23.4985 0C34.5442 0 40 12.4528 40 23.4985Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 23.4985C40 34.5442 27.5472 40 16.5015 40C13.0326 40 10.115 38.7718 7.74459 36.7448C8.06012 36.0856 8.39689 35.3723 8.74564 34.6336C9.42926 33.1856 10.159 31.6401 10.865 30.2136C13.2892 32.3833 16.4905 33.7026 20 33.7026C27.5678 33.7026 33.7026 27.5678 33.7026 20C33.7026 12.4322 27.5678 6.29738 20 6.29738C12.4322 6.29738 6.29738 12.4322 6.29738 20C6.29738 23.3329 7.48729 26.3879 9.46547 28.7633C8.71465 30.3786 7.83568 32.1522 7.01979 33.7986C6.76241 34.3179 6.51128 34.8247 6.27245 35.3098C2.08029 30.6793 0 23.3221 0 16.5015C0 5.45576 12.4528 0 23.4985 0C34.5442 0 40 12.4528 40 23.4985Z",
    fill: "url(#paint0_linear_1035_19450)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7439 28.482C12.8791 26.313 13.8635 24.7424 14.3634 24.8072C15.4818 24.9521 16.8566 24.8744 18.257 22.1843C19.3774 20.0323 20.4254 16.201 20.8093 14.5544L19.9666 14.1467L16.4719 21.3702C16.3003 21.7248 15.8738 21.8732 15.5192 21.7016C15.1645 21.5301 15.0161 21.1035 15.1877 20.7489L18.6824 13.5254L17.3982 12.9041L13.9035 20.1276C13.732 20.4822 13.3054 20.6306 12.9508 20.4591C12.5962 20.2875 12.4478 19.861 12.6193 19.5063L16.114 12.2828L15.2757 11.8772C14.2229 13.2003 11.8694 16.3999 10.8774 18.6141C9.63746 21.3818 10.4298 22.508 11.2376 23.295C11.5543 23.6035 11.1158 24.9853 10.331 26.8295C8.96561 24.8999 8.16327 22.5437 8.16327 20C8.16327 13.4628 13.4628 8.16327 20 8.16327C26.5372 8.16327 31.8367 13.4628 31.8367 20C31.8367 26.5372 26.5372 31.8367 20 31.8367C16.7888 31.8367 13.8763 30.558 11.7439 28.482Z",
    fill: "url(#paint1_linear_1035_19450)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1035_19450",
    x1: 20.0635,
    y1: -28,
    x2: 54.3483,
    y2: 39.5455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4A35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1035_19450",
    x1: 20.0635,
    y1: -28,
    x2: 54.3483,
    y2: 39.5455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4A35"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.e1e9dfd9533d35d286c9bfafdf8fa6f4.svg";
export { ForwardRef as ReactComponent };